import { Injectable, inject } from '@angular/core';
import { Subject, Observable, firstValueFrom } from 'rxjs';
import { BeschreibungOptions, BeschreibungState } from '../types/beschreibung-types';
import { MrTranslatePipe } from '../pipes/mr-translate.pipe';

@Injectable({ providedIn: 'root' })
export class BeschreibungService {
  private mrTranslate = inject(MrTranslatePipe);

  private state$ = new Subject<BeschreibungState>();
  confirmState$ = this.state$.asObservable();

  show(options: BeschreibungOptions): Observable<boolean> {
    const result$ = new Subject<boolean>();

    this.state$.next({
      options: {
        okText: this.mrTranslate.transform('OK'),
        ...options,
      },
    });

    return result$.asObservable();
  }

  async confirmAsync(options: BeschreibungOptions): Promise<boolean> {
    return firstValueFrom(this.show(options));
  }
}
